<template>
  <a-modal
    title="生成条码"
    v-model="visible"
    okText="生成条码"
    cancelText="取消"
    :bodyStyle="{ minHeight: '300px' }"
    width="1300px"
    @ok="handleOk"
    @cancel="handleCancel"
    :confirmLoading="confirmLoading"
  >
    <a-form :form="form">
      <a-form-item label v-show="false">
        <a-input v-decorator="['InvCode']" />
        <a-input v-decorator="['Code']" />
      </a-form-item>
      <a-form-item label v-show="false">
        <a-input v-decorator="['cbatch']" />
      </a-form-item>
      <a-row :gutter="24">
        <a-col :xs="24" :sm="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="单据类型">
            <span class="rightLabel">ASN单</span>
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="ASN单号">
            <span class="rightLabel">{{ baseInfo.ccode }}</span>
            <!-- <span style="padding-left:10px">行号：</span>
            <span class="rightLabel">{{ baseInfo.irowno ? baseInfo.irowno : '-' }}</span> -->
            <!-- <a-input placeholder="ASN单号" v-decorator="['Code']" :disabled="true" /> -->
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :xs="24" :sm="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="物料编码">
            <span class="rightLabel">{{ baseInfo.cinvcode }}</span>
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="物料名称">
            <span class="rightLabel">{{ baseInfo.cinvname }}</span>
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="规格型号">
            <span class="rightLabel">{{ baseInfo.cinvstd }}</span>
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数量">
            <span class="rightLabel">{{ baseInfo.iquantity }}</span>
            <span class="rightLabel">{{ baseInfo.cinvm_unit }}</span>
            <!-- 数量及数量单位 -->
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <!-- 件数及件数单位 -->
        <!-- <a-col :xs="24" :sm="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="件数">
            <span class="rightLabel">{{ baseInfo.inum }}</span>
            <span class="rightLabel">{{ baseInfo.cinva_unit }}</span>
          </a-form-item>
        </a-col> -->
      </a-row>
      <a-row :gutter="24">
        <a-col :xs="24" :sm="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="条码规则">
            <a-select v-decorator="['BarRule', { rules: [{ required: true, message: '条码规则不能为空!' }] }]">
              <a-select-option v-for="(item, index, key) in barruleList" :value="item.ruleid" :key="key">{{ item.rulename }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="条码依据">
            <a-select v-decorator="['BatchMode']" @change="e => ruleChange(e)">
              <a-select-option v-for="(item, index, key) in batchmodeList" :value="item.enumcode" :key="key">{{ item.enumname }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :xs="24" :sm="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="已生码数量">
            <a-input-number style="width:100%" placeholder="本次生码数量" v-decorator="['ysmsl']" :disabled="true" />
          </a-form-item>
          <!-- <a-input placeholder="已生成条码数量" v-decorator="['iquantity']" :disabled="true" /> -->
        </a-col>
        <a-col :xs="24" :sm="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="本次生码数量">
            <a-input-number style="width:100%" placeholder="本次生码数量" v-decorator="['iquantity']" />
          </a-form-item>
        </a-col>
        <!-- <a-col :xs="24" :sm="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="已生码件数">
            <span class="rightLabel">{{ baseInfo.inum }}</span>

          </a-form-item>
        </a-col> -->
      </a-row>

      <!-- <a-row :gutter="24">

        <a-col :xs="24" :sm="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="本次生码件数">
            <a-input-number style="width:100%" placeholder="本次生码件数" v-decorator="['BarCodeNum']" />
          </a-form-item>
        </a-col>
      </a-row> -->
      <a-row :gutter="24">
        <a-col :xs="24" :sm="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="码内数量">
            <a-input-number
              style="width:100%"
              placeholder="码内数量"
              :min="0"
              @change="e => tmbzChange(e)"
              v-decorator="['BarCodeQty', { rules: [{ required: true, message: '码内数量不能为空!' }] }]"
            />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="条码个数">
            <a-input-number style="width:100%" placeholder="条码个数" v-decorator="['BarCodeNum']" :disabled="issg" />
          </a-form-item>
        </a-col>
        <!-- <a-col :xs="24" :sm="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="码内件数">
            <a-input-number style="width:100%" placeholder="码内件数" v-decorator="['BarCodeNum']" />
          </a-form-item>
        </a-col> -->
      </a-row>
      <a-row :gutter="24">
        <!-- <a-col :xs="24" :sm="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="条码包装数量">
            <a-input placeholder="条码包装数量" @change="e => tmbzChange(e)" v-decorator="['BarCodeQty']" />
          </a-form-item>
        </a-col> -->
      </a-row>
    </a-form>
  </a-modal>
</template>
<script>
import { getBarRule, getBatchMode, getBarCodes, asnGetBarcode } from '@/api/scmApi'

export default {
  name: 'CreateBarcode',
  data() {
    return {
      visible: false,
      autoid: null,
      form: this.$form.createForm(this),
      confirmLoading: false,
      barruleList: [],
      batchmodeList: [],
      issg: true,
      U8UserInfo: this.$store.getters.U8UserInfo,
      labelCol: { xs: { span: 24 }, sm: { span: 7 } },
      wrapperCol: { xs: { span: 24 }, sm: { span: 16 } },
      baseInfo: {},
      bodyInfo: null,
      ccode: ''
    }
  },
  computed: {
    hasSelectedCount() {
      return this.hasSelectedRecordsTemp.length
    }
  },
  mounted() {},
  methods: {
    toOpen() {
      this.visible = true
    },

    ruleChange(e) {
      const _that = this
      if (e === '数量') {
        _that.issg = true
        _that.form.setFieldsValue({ BarCodeNum: _that.baseInfo['iquantity'], BarCodeQty: _that.baseInfo['iquantity'] })
        // _that.form.setFieldsValue({ BarCodeNum: _that.form.getFieldValue('iquantity'), BarCodeQty: _that.form.getFieldValue('iquantity') })
      } else if (e === '件数') {
        _that.issg = true
        _that.form.setFieldsValue({ BarCodeNum: _that.baseInfo['inum'], BarCodeQty: _that.baseInfo['inum'] })
        // _that.form.setFieldsValue({ BarCodeNum: _that.form.getFieldValue('inum'), BarCodeQty: _that.form.getFieldValue('inum') })
      } else if (e === '手工输入') {
        _that.form.setFieldsValue({ BarCodeNum: null, BarCodeQty: null })
        _that.issg = false
      }
    },
    tmbzChange(e) {
      const _that = this
      setTimeout(() => {
        if (_that.form.getFieldValue('BarCodeQty') != '0')
          _that.form.setFieldsValue({ BarCodeNum: Math.ceil(_that.form.getFieldValue('iquantity') / _that.form.getFieldValue('BarCodeQty')) })
        else _that.$message.warning('请输入大于0的整数')
      }, 1000)
    },
    handleCancel() {
      this.visible = false
    },
    //生成条码的方法
    toGetCode(ccode, record) {
      console.log('record', record)
      this.bodyInfo = record
      this.ccode = ccode
      this.visible = true
      this.baseInfo = {}
      this.confirmLoading = false
      this.$nextTick(() => {
        this.form.resetFields()
        this.baseInfo['ccode'] = ccode
        this.baseInfo['cinvcode'] = record.cinvcode
        this.baseInfo['cinvname'] = record.cinvname
        this.baseInfo['cinvstd'] = record.cinvstd
        this.baseInfo['iquantity'] = record.iquantity
        this.baseInfo['inum'] = record.inum
        this.baseInfo['cbatch'] = record.cbatch
        this.form.setFieldsValue({
          Code: ccode,
          InvCode: record.cinvcode,
          // cinvname: record.cinvname,
          // cinvstd: record.cinvstd,
          // iquantity: record.iquantity,
          // inum: record.inum,
          ysmsl: '',
          BarCodeNum: record.iquantity,
          BarCodeQty: record.iquantity,
          cbatch: record.cbatch
          // cinvm_unit: record.cinvm_unit
        })
      })
      this.autoid = record.autoid //从asn单查看界面进来后可以直接选到autoid
      this.loadInfo(ccode, record.cinvcode)
      // this.getAutoid(ccode) //从asn单维护界面进来时无法获得autoid，所以用该方法去调用
    },
    //开发版获取autoid
    // getAutoid(ccode) {
    //   getASNByCCode({ ccode: ccode })
    //     .then(res => {
    //       if (res.code === 0 || res.code === '0') {
    //         this.autoid = res.body[0].autoid
    //       } else {
    //         this.$message.error(res.msg)
    //       }
    //     })
    //     .catch(function() {
    //       this.$message.error('获取ASN单信息发生异常!')
    //     })
    // },
    handleOk() {
      const _that = this
      this.confirmLoading = true
      if (_that.U8UserInfo) {
        _that.form.validateFields((err, values) => {
          if (!err) {
            if (values.BarCodeNum > 1000) {
              this.$confirm({
                title: `当前条码个数为${values.BarCodeNum}`,
                content: h => <div style="color:red;">生码个数超过1000，是否继续生码?</div>,
                onOk() {
                  const params = { ...values }
                  params['VouchType'] = 'puas'
                  params['autoid'] = _that.autoid
                  params['Context'] = JSON.stringify(_that.U8UserInfo)
                  getBarCodes(params)
                    .then(res => {
                      if (res.code === 0 || res.code === '0') {
                        _that.$message.success('生成条码成功!')
                        _that.confirmLoading = false
                        _that.visible = false
                        _that.$emit('success')
                      } else {
                        _that.$message.error(res.msg)
                        _that.confirmLoading = false
                      }
                    })
                    .catch(function() {
                      _that.$message.error('获取条码信息失败!')
                      _that.confirmLoading = false
                    })
                },
                onCancel() {
                  _that.confirmLoading = false
                  return
                }
              })
            } else {
              const params = { ...values }
              params['VouchType'] = 'puas'
              params['autoid'] = _that.autoid
              params['Context'] = JSON.stringify(_that.U8UserInfo)
              getBarCodes(params)
                .then(res => {
                  if (res.code === 0 || res.code === '0') {
                    _that.$message.success('生成条码成功!')
                    _that.confirmLoading = false
                    _that.visible = false
                    _that.$emit('success')
                  } else {
                    _that.$message.error(res.msg)
                    _that.confirmLoading = false
                  }
                })
                .catch(function() {
                  _that.$message.error('获取条码信息失败!')
                  _that.confirmLoading = false
                })
            }
          }
        })
      } else {
        _that.$message.warn('登录信息已过期,请重新登录!')
      }
    },
    loadInfo(ccode, cinvcode) {
      const _that = this
      getBarRule({ ccode: ccode, cinvcode: cinvcode })
        .then(res => {
          if (res.code === 0 || res.code === '0') {
            if (res.data.length > 0) {
              _that.barruleList = res.data
              _that.form.setFieldsValue({ BarRule: _that.barruleList[0].ruleid })
              _that.getNum(res.data[0].ruleid)
            }
          } else {
            _that.$message.error(res.msg)
          }
        })
        .catch(function() {
          _that.$message.error('获取条码规则发生异常!')
        })
      getBatchMode()
        .then(res => {
          if (res.code === 0 || res.code === '0') {
            _that.batchmodeList = res.data
            _that.form.setFieldsValue({ BatchMode: '手工输入' })
            _that.form.setFieldsValue({ BarCodeNum: null, BarCodeQty: null })
            _that.issg = false
          } else {
            _that.$message.error(res.msg)
          }
        })
        .catch(function() {
          _that.$message.error('获取条码数依据发生异常!')
        })
    },
    getNum(ruleid) {
      const that = this
      const params = {
        autoid: this.bodyInfo.autoid,
        barcoderule: ruleid,
        ccode: this.ccode
      }
      asnGetBarcode(params).then(res => {
        if (res.code == 0) {
          that.$nextTick(() => {
            that.form.resetFields({ ysmsl: 0 })
            that.form.setFieldsValue({
              ysmsl: res.data,
              iquantity: Number(that.baseInfo.iquantity) - Number(res.data)
            })
          })
        } else {
          that.resetFields({
            ysmsl: 0
          })
        }
      })
    }
  }
}
</script>
